import TroubleshootingComp from '../../app/features/Troubleshooting';
const TroubleshootingPage = () => {
    return (
        <TroubleshootingComp />
    )
}
export default TroubleshootingPage